export default "__VITE_ASSET__p0HR7J_2__"